import React from "react";
import styled from "styled-components";
import iconRank1 from "../../../../../assets/images/Mini-Game/icon-rank-mini-1.png";
import iconRank2 from "../../../../../assets/images/Mini-Game/icon-rank-mini-2.png";
import iconRank3 from "../../../../../assets/images/Mini-Game/icon-rank-mini-3.png";
import iconRank1NewYear from "../../../../../assets/images/Mini-Game/new-year-2025/icon-ranking.png";
import iconRank1Thadingyut from "../../../../../assets/images/Mini-Game/thadingyut-2025-theme/rank-icon.png";
import iconRank2Thadingyut from "../../../../../assets/images/Mini-Game/thadingyut-2025-theme/rank-mini-2-icon.png";
import iconRank3Thadingyut from "../../../../../assets/images/Mini-Game/thadingyut-2025-theme/rank-mini-3-icon.png";
import {
  HIDDEN_POPUP_RANKING_MINIGAME,
  useNewYear2025Theme,
  useThadingyutTheme,
  // IS_EVENT_THADINGYUT_2025_THEME,
} from "../../../../../helper/const";

export default function IconRanking({
  isShowBtnClose = false,
  onClose = () => {},
}) {
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();
  if (HIDDEN_POPUP_RANKING_MINIGAME) {
    return <></>;
  }

  if (!IS_EVENT_NEW_YEAR_2025_THEME) {
    return (
      <Container>
        <div className="container-icon-event-2025 container-icon-event-2025__minigame">
          {isShowBtnClose ? (
            <i
              className="fa fa-times icon-close-event-2025"
              aria-hidden="true"
              onClick={onClose}
            />
          ) : (
            <></>
          )}
          {IS_EVENT_THADINGYUT_2025_THEME ? (
            <div className="slideshow no-animation">
              <img
                srcSet={`${iconRank1Thadingyut} 2x`}
                className="active scale-hover-item"
              />
              {/* <img srcSet={`${iconRank2Thadingyut} 2x`} className='fade' /> */}
              {/* <img srcSet={`${iconRank3Thadingyut} 2x`} className='fade' /> */}
            </div>
          ) : IS_EVENT_NEW_YEAR_2025_THEME ? (
            <div className="slideshow no-animation">
              <img
                srcSet={`${iconRank1NewYear} 2x`}
                className="active scale-hover-item"
              />
              {/* <img src={iconRank2} className='fade' />
            {/* <img src={iconRank3} className='fade' /> */}
            </div>
          ) : (
            <div className="slideshow no-animation">
              <img src={iconRank1} className="active scale-hover-item" />
              {/* <img src={iconRank2} className='fade' /> */}
              {/* <img src={iconRank3} className='fade' /> */}
            </div>
          )}
        </div>
      </Container>
    );
  }
  return (
    <Container>
      <div className="container-icon-event-2025 container-icon-event-2025__minigame">
        {isShowBtnClose ? (
          <i
            className="fa fa-times icon-close-event-2025"
            aria-hidden="true"
            onClick={onClose}
          />
        ) : (
          <></>
        )}
        {IS_EVENT_THADINGYUT_2025_THEME ? (
          <div className="slideshow">
            <img srcSet={`${iconRank1Thadingyut} 2x`} className="active" />
            <img srcSet={`${iconRank2Thadingyut} 2x`} className="fade" />
            <img srcSet={`${iconRank3Thadingyut} 2x`} className="fade" />
          </div>
        ) : IS_EVENT_NEW_YEAR_2025_THEME ? (
          <div className="slideshow">
            <img srcSet={`${iconRank1NewYear} 2x`} className="active" />
            <img src={iconRank2} className="fade" />
            <img src={iconRank3} className="fade" />
          </div>
        ) : (
          <div className="slideshow">
            <img src={iconRank1} className="active" />
            <img src={iconRank2} className="fade" />
            <img src={iconRank3} className="fade" />
          </div>
        )}
      </div>
    </Container>
  );
}

const Container = styled.div`
  cursor: pointer;
  .container-icon-event-2025.container-icon-event-2025__minigame {
    bottom: 30%;
    right: 15px;
  }

  @media (max-height: 700px) {
    .container-icon-event-2025.container-icon-event-2025__minigame {
      bottom: 40%;
    }
  }

  @media (max-height: 575px) {
    .container-icon-event-2025.container-icon-event-2025__minigame {
      bottom: 40%;
    }
  }

  @media (max-height: 475px) {
    .container-icon-event-2025.container-icon-event-2025__minigame {
      bottom: 45%;
    }
  }

  @media (max-height: 392px) {
    .container-icon-event-2025.container-icon-event-2025__minigame {
      bottom: 50%;
    }
  }

  @media (max-height: 375px) {
    .container-icon-event-2025.container-icon-event-2025__minigame {
      bottom: 55%;
    }
  }

  .slideshow {
    width: 85px;
    height: 82px;
    position: relative;
    overflow: auto;

    &.no-animation {
      img {
        animation: none !important;
        opacity: 1 !important;
      }
    }
  }

  .slideshow img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    animation: fade 7.5s infinite;
  }

  .slideshow img:nth-child(1) {
    animation-delay: 0s;
  }

  .slideshow img:nth-child(2) {
    animation-delay: 2.5s;
  }

  .slideshow img:nth-child(3) {
    animation-delay: 5s;
  }

  @keyframes fade {
    0% {
      opacity: 0;
      transform: scale(1);
    }
    10% {
      opacity: 1;
      transform: scale(1);
    }
    30% {
      opacity: 1;
      transform: scale(1);
    }
    40% {
      opacity: 0;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
  }

  @media (min-width: 992px) {
    .slideshow:hover {
      cursor: pointer;
      scale: 1.05;
      transition: 0.3s ease-in-out;
    }
  }

  @media (max-width: 576px) {
    .container-icon-event-2025.container-icon-event-2025__minigame {
      bottom: 260px;
      right: 40px;
    }
    .slideshow {
      width: 65px;
      height: 62px;
    }
  }
`;
